/* eslint-disable react-hooks/exhaustive-deps */
import React, {
	FC,
	ForwardedRef,
	forwardRef,
	useImperativeHandle,
	useMemo,
} from "react";
import type { ConstructorOf } from "../types/ConstructorOf";

export function setRefValue<T>(ref: ForwardedRef<T>, value: T) {
	if (!ref) return;

	if (typeof ref === "function") ref(value);
	else (ref as React.MutableRefObject<T>).current = value;
}

export class ControllerBase<Context = unknown> {
	protected context: Context | null = null;

	setContext(value: Context | null) {
		this.context = value;
	}
}

export function withController<Props, ControllerType>(
	Component: FC<Props & { controller: ControllerType }>,
	Controller: ConstructorOf<ControllerType>,
) {
	return forwardRef<ControllerType | null, Props>((props, ref) => {
		const controller = useMemo(() => new Controller(), []) as ControllerType;

		useImperativeHandle(ref, () => controller, [controller]);

		return <Component {...(props as any)} controller={controller} />;
	});
}
